const viteEnv = import.meta.env || {};

export const getEnv = () => {
  // eslint-disable-next-line no-undef
  const windowEnv = typeof window !== "undefined" && window["env"] ? window["env"] : {};
  const env = {
    ...viteEnv,
    ...windowEnv,
  };

  const convertedEnv = {};

  Object.keys(env).forEach((key) => {
    if (key.startsWith("VITE_")) {
      const reactAppKey = key.replace("VITE_", "REACT_APP_");

      convertedEnv[reactAppKey] = env[key];
    }
  });

  return {
    ...env,
    ...convertedEnv,
  };
};

export const env = getEnv();
